import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getUserProfileSkeleton, UserProfile } from "@skyportal/auth-web-client";
import { AppStateSlice } from "store/types/appSlice.types";

const initialState: AppStateSlice = {
  userProfile: getUserProfileSkeleton(),
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setUserProfile(state, action: PayloadAction<UserProfile>) {
      state.userProfile = action.payload;
    },
  },
});

export const { setUserProfile } = appSlice.actions;

export default appSlice.reducer;
